import React from 'react';
import style from '../css/CorporateTravel.module.css';
import image1 from '../assets/images/IMG-20250826-WA0041_1.jpg';
import image2 from '../assets/images/giby.png';
import image3 from '../assets/images/support.png';
import image4 from '../assets/images/global.png';

function CorporateTravel() {
	return (
		<div className={style.wrapper}>
			<div className={style.imageStack}>
				<img src={image1} alt="Beach" className={style.mainImage} />
				<div className={style.overlayCard}>
					<img src={image2} alt="Boats" className={style.overlayImage} />
					<div className={style.cardText}>
						<h4>Bespoke Itineraries</h4>
						<p>
							We customize every trip meticulously to fit your company’s
							needs—from flights to ground transportation.
						</p>
					</div>
				</div>
			</div>

			<div className={style.wrapperTxt}>
				<h2>We provide end-to-end travel solutions, including: </h2>
				<p className={style.description}>
					✈️ Flight bookings (domestic & international) <br />
					🏨 Hotel accommodations (budget to luxury) <br />
					🚆 Train & Bus tickets (with real-time availability support) <br />
					🚗 Car rentals on request (chauffeur-driven)
				</p>

				<div className={style.statsRow}>
					<div className={style.stat}>
						<h3>81%</h3>
						<p>From concept to completion</p>
					</div>
					<div className={style.iconCard}>
						<img src={image3} alt="Concierge" />
						<p>24/7 Concierge Support</p>
					</div>
					<div className={style.iconCard}>
						<img src={image4} alt="Experience" />
						<p>Global Booking Access</p>
					</div>
				</div>
			</div>
		</div>
	);
}

export default CorporateTravel;
